import { InfoWindow } from '@vis.gl/react-google-maps'
import { YesObject } from '@yes.technology/react-toolkit'
import { useCallback, useState } from 'react'
import { DeliveryPointInfoWindow } from './DeliveryPointInfoWindow'
import MapInfoWindowHeader from './MapInfoWindowHeader'
import MapMarker from './MapMarker'

const MAP_POSTIION_OFFSET_Y = -50

type MapMarkerPlacementProps = {
  markers: YesObject[]
}

const MapMarkerPlacement = ({ markers }: MapMarkerPlacementProps) => {
  const [activeMarkerId, setActiveMarkerId] = useState<string | null>()
  const [activeMarkerCoordinates, setActiveMarkerCoordinates] =
    useState<google.maps.LatLngLiteral>()

  const handleOpenMarker = useCallback(
    (id: string | undefined, coordinates: google.maps.LatLngLiteral) => {
      setActiveMarkerId(id)
      setActiveMarkerCoordinates(coordinates)
    },
    []
  )

  const openedMarker = activeMarkerId
    ? markers.find((m) => m.uuid === activeMarkerId)
    : null

  return (
    <>
      {markers.map((object) => (
        <MapMarker
          key={object.uuid}
          object={{ ...object }}
          isOpened={activeMarkerId === object.uuid}
          onOpenMarker={handleOpenMarker}
        />
      ))}
      {activeMarkerCoordinates && openedMarker && (
        <InfoWindow
          position={activeMarkerCoordinates}
          pixelOffset={[0, MAP_POSTIION_OFFSET_Y]}
          shouldFocus
          minWidth={350}
          maxWidth={430}
          headerContent={
            <MapInfoWindowHeader onClose={() => setActiveMarkerId(null)} />
          }
        >
          <DeliveryPointInfoWindow object={openedMarker} />
        </InfoWindow>
      )}
    </>
  )
}

export default MapMarkerPlacement
